import { useEffect, useState } from "react";
import { api } from "./api";

export type Me = {
  email: string;
  roles: string[];
  csrf: string;
  activeRole: string;
  activeLearnerId: string | null;
  parentUnlocked: boolean;
  restrictedChild: boolean;
} | null;

export function useMe() {
  const [me, setMe] = useState<Me>(undefined as unknown as Me);
  useEffect(() => {
    api<Me>("/api/v1/me").then(setMe).catch(() => setMe(null));
  }, []);
  return [me, setMe] as const;
}

export function safeNext(raw: string | null, fallback = "/app"): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//")) return fallback;
  return raw;
}

export function isRestrictedChild(me: Me): boolean {
  return Boolean(me?.restrictedChild);
}

export function canManageFamily(me: Me, hasPin: boolean): boolean {
  if (!me || me.restrictedChild) return false;
  if (!hasPin) return true;
  return me.parentUnlocked;
}

export function isChildView(me: Me): boolean {
  if (!me) return true;
  if (me.restrictedChild) return true;
  return me.activeRole === "learner" && !me.parentUnlocked;
}
